"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CreateModel {
    static getAttributeTypeMap() {
        return CreateModel.attributeTypeMap;
    }
}
CreateModel.discriminator = undefined;
CreateModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    }
];
exports.CreateModel = CreateModel;
//# sourceMappingURL=createModel.js.map